import React from 'react';

export const PersonalizedSearchLinkIcon = () => {
  return (
    <span className="gradient-circle d-flex align-items-center justify-content-center align-self-start rounded-circle me-1">
      <span className="icon-magic-search icon medium" aria-hidden />
    </span>
  );
};
